import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const EcaCtaBanner: React.FC = () => (
  <section className="wdev-cta" aria-labelledby="eca-cta-title">
    <div className="container">
      <AnimatedSection>
        <motion.div className="wdev-cta__inner" whileHover={{ scale: 1.005 }} transition={{ duration: 0.3 }}>
          <div className="wdev-cta__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M6 6h15l-1.5 9H7.5L6 6Z" stroke="#2563eb" strokeWidth="1.5" strokeLinejoin="round" />
              <path d="M6 6L5 3H2" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </div>
          <div className="wdev-cta__text">
            <h2 id="eca-cta-title" className="wdev-cta__title">
              Ready to Launch Your E-Commerce App?
            </h2>
            <p className="wdev-cta__subtitle">
              Get a demo of our online store and marketplace platform — customer, vendor, and admin in one solution.
            </p>
          </div>
          <Link to="/contact" className="wdev-cta__btn">
            Get In Touch
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </motion.div>
      </AnimatedSection>
    </div>
  </section>
);

export default EcaCtaBanner;
